export default {
  sm: `
  GAK Sejong utilizes natural wind to lower the temperature in the server rooms. It is located in a great location to run an eco-friendly data center, using the cold wind coming from the northwest through the Geumgang River to increase cooling efficiency.
  `,
};
